import ExaminationEventPolicies from './ExaminationEventPolicies';

export default ExaminationEventPolicies;
